import { render, staticRenderFns } from "./retail.vue?vue&type=template&id=65456ebe&scoped=true&"
import script from "./retail.vue?vue&type=script&lang=js&"
export * from "./retail.vue?vue&type=script&lang=js&"
import style0 from "./retail.vue?vue&type=style&index=0&id=65456ebe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65456ebe",
  null
  
)

export default component.exports